import classNames from 'classnames';
import styles from './list-summary.module.scss';
import type { IListSummaryProps } from './types';

export const ListSummary = (props: IListSummaryProps) => {
  const { isLoading = false, className, children } = props;

  const elementClasses = classNames(styles.summary, className, {
    [styles.hidden]: isLoading,
  });

  return <div className={elementClasses}>{children}</div>;
};
